import * as Types from '../../../../../app.types.generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type PanelsListQueryVariables = Types.Exact<{
  input?: Types.Maybe<Types.GetPanelsInput>;
}>;


export type PanelsListQuery = (
  { __typename: 'Query' }
  & { getPanels: (
    { __typename: 'PanelLIstResponse' }
    & Pick<Types.PanelLIstResponse, 'count' | 'limit' | 'skip'>
    & { result: Array<(
      { __typename: 'BasePanel' }
      & Pick<Types.BasePanel, 'createdAt' | 'openCareGapCount' | 'complianceRate' | 'patientCount' | 'name' | 'id' | 'unassignedPatientCount' | 'assignedPatientCount'>
      & { careGapCount?: Types.Maybe<(
        { __typename: 'CareGapCount' }
        & Pick<Types.CareGapCount, 'close' | 'closeRate' | 'open'>
      )>, careTeamUsers: Array<(
        { __typename: 'CareTeamMember' }
        & Pick<Types.CareTeamMember, 'count'>
        & { user: (
          { __typename: 'User' }
          & Pick<Types.User, 'firstName' | 'lastName' | 'title'>
        ) }
      )> }
    )> }
  ) }
);


export const PanelsListDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PanelsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetPanelsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPanels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openCareGapCount"}},{"kind":"Field","name":{"kind":"Name","value":"careGapCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"close"}},{"kind":"Field","name":{"kind":"Name","value":"closeRate"}},{"kind":"Field","name":{"kind":"Name","value":"open"}}]}},{"kind":"Field","name":{"kind":"Name","value":"complianceRate"}},{"kind":"Field","name":{"kind":"Name","value":"patientCount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openCareGapCount"}},{"kind":"Field","name":{"kind":"Name","value":"careTeamUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unassignedPatientCount"}},{"kind":"Field","name":{"kind":"Name","value":"assignedPatientCount"}}]}}]}}]}}]};

/**
 * __usePanelsListQuery__
 *
 * To run a query within a React component, call `usePanelsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePanelsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePanelsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePanelsListQuery(baseOptions?: Apollo.QueryHookOptions<PanelsListQuery, PanelsListQueryVariables>) {
        return Apollo.useQuery<PanelsListQuery, PanelsListQueryVariables>(PanelsListDocument, baseOptions);
      }
export function usePanelsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PanelsListQuery, PanelsListQueryVariables>) {
          return Apollo.useLazyQuery<PanelsListQuery, PanelsListQueryVariables>(PanelsListDocument, baseOptions);
        }
export type PanelsListQueryHookResult = ReturnType<typeof usePanelsListQuery>;
export type PanelsListLazyQueryHookResult = ReturnType<typeof usePanelsListLazyQuery>;
export type PanelsListQueryResult = Apollo.QueryResult<PanelsListQuery, PanelsListQueryVariables>;
export function refetchPanelsListQuery(variables?: PanelsListQueryVariables) {
      return { query: PanelsListDocument, variables: variables }
    }